import { Button, Spinner } from "react-bootstrap";
import "./index.css";

export default function CommonButton({
  icon = null,
  type,
  variant = "primary",
  title,
  disabled = false,
  isLoading = false,
  className = "",
  style,
  ...rest
}) {
  return (
    <Button
      variant={variant}
      type={type}
      disabled={disabled || isLoading}
      style={style}
      className={`rounded-2 common-btn text-capitalize ${className}`}
      {...rest}
    >
      {isLoading ? (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          className="me-2"
        />
      ) : (
        icon && (
          <i className="d-flex align-items-center justify-content-center">
            {icon}
          </i>
        )
      )}
      {title && <span>{title}</span>}
    </Button>
  );
}
